import { ServiceWorkerStatus } from './types'

export function getServiceWorkerStatus(): ServiceWorkerStatus {
  if (window.navigator && window.navigator.serviceWorker) {
    return window.navigator.serviceWorker.controller ? ServiceWorkerStatus.CONTROLLED : ServiceWorkerStatus.SUPPORTED
  } else {
    return ServiceWorkerStatus.UNSUPPORTED
  }
}
